import { CartService } from '../cart.service';
import { Association } from './assoication';
import { CartModel } from './cart.model';
import { PackageModel } from './package.model';
import { MemberTypeModel } from './member-type.model';

export interface WizardMembershipSelection {
  Level: 'Professional' | 'Associate' | 'Student' | 'Graduate';
  Membership: string; // mbt_key
  Type: MemberTypeModel;
  Skip: boolean; // Skip creating membership for various student use-cases
  DiscountCode: string;
}

export class WizardModel {
  public Associations: { [Asn in Association]: boolean } = {
    'ABMP': false,
    'ASCP': false,
    'AHP': false,
    'ANP': false
  }

  public Memberships: { [Asn in Association]: WizardMembershipSelection } = {
    'ABMP': null,
    'ASCP': null,
    'AHP': null,
    'ANP': null
  }

  public PackageCombo: PackageModel = null;

  public BPP: number = null;

  public AutoRenew: boolean = false;

  public AffinityID: number = null;

  public get Cart(): CartModel {
    return this.cart.Data;
  }

  constructor(private cart: CartService, source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          if (key === 'Cart') {
            continue;
          }

          this[key] = source[key];
        }
      }
    }
  }

  public toJSON(key): any {
    return {
      Associations: this.Associations,
      Memberships: this.Memberships,
      PackageCombo: this.PackageCombo,
      BPP: this.BPP,
      AutoRenew: this.AutoRenew,
      AffinityID: this.AffinityID,
      Cart: this.cart.Data
    };
  }

  public Subtotals(): Array<{ item: string, type: string, price: number }> {
    let results = [];

    if (this.PackageCombo && this.Cart == null) {
      results.push({
        item: this.PackageCombo.p02_combo_description,
        price: this.PackageCombo.p02_combo_price,
        type: 'Membership Dues'
      });
    } else if (this.Cart) {
      results = this.cart.Subtotals();
    }

    return results;
  }

  public get Dues(): number {
    return this.Subtotals()
      .filter(item => item.type === 'Membership Dues')
      .reduce((previous, item) => previous + (isNaN(item.price) ? 0 : item.price), 0);
  }

  public get Subscriptions(): number {
    return this.Subtotals()
      .filter(item => item.type === 'Subscription')
      .reduce((previous, item) => previous + (isNaN(item.price) ? 0 : item.price), 0);
  }

  public get Other(): number {
    return this.Subtotals()
      .filter(item => item.type !== 'Subscription' &&  item.type !== 'Membership Dues')
      .reduce((previous, item) => previous + (isNaN(item.price) ? 0 : item.price), 0);
  }

  public get Subtotal(): number {
    return this.Subtotals().reduce((previous, item) => previous + (isNaN(item.price) ? 0 : item.price), 0);
  }
}
